import { Module } from 'vuex';

export enum AlertLevelType {
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error'
}

export interface AlertMessage {
  type: AlertLevelType;
  message: string;
}

export const alertStore: Module<any, any> = {
  state: {
    dismissSecs: 0,
    dismissCountDown: 0,
    alertMessage: <AlertMessage>{}
  },
  getters: {
    dismissSecs: state => state.dismissSecs,
    dismissCountDown: state => state.dismissCountDown,
    alertMessage: state => state.alertMessage,
    getAlertMessage: state => () => state.alertMessage
  },
  mutations: {
    initAlert(state) {
      state.dismissSecs = 0;
      state.dismissCountDown = 0;
      state.alertMessage = {};
    },
    setAlertMessage(state, alertMessage: AlertMessage) {
      state.dismissSecs = 5;
      state.dismissCountDown = 5;
      state.alertMessage = alertMessage;
    },
    countDownChanged(state, newCountDown) {
      state.dismissCountDown = newCountDown;
    }
  }
};
